<template>
    <div class="fleet-notifications-view">
        <div class="info-block">
            Edit Notifications
        </div>
        <v-tabs fixed-tabs background-color="#1d2a39" dark v-model="tab">
            <v-tab key="alert-notification-email">
                Alert Notification Email
            </v-tab>
            <v-tab key="device-notification">
                Device Notifications
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item key="alert-notification-email">
                <v-container fluid>
                    <v-layout row>
                        <v-flex class="section">
                            <div class="section-title">Alert Notification Emails</div>
                            <v-layout row wrap v-if="!fieldCategoriesEmpty">
                                <v-flex md6 class="section notification-group" v-for="category in availableCategories" :key="`group_${category.key}`">
                                    <v-layout row>
                                        <v-flex shrink text-center>
                                            <div class="label label--category">
                                                {{ category.name }}
                                            </div>
                                        </v-flex>
                                        <v-flex shrink>
                                            <v-checkbox v-model="fields.categories[category.key].isAll" @change="checkAllEvents($event, category.key)" class="notification-checkbox"></v-checkbox>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-layout row v-for="eventType in getEventsOfCategory(category.id)">
                                            <v-flex shrink text-center>
                                                <div class="label">
                                                    {{ eventType.name }}
                                                </div>
                                            </v-flex>
                                            <v-flex shrink>
                                                <v-checkbox v-model="settings.categories[category.key].eventTypes" :value="eventType.id" @change="checkEventTypes(category.key)" class="notification-checkbox"></v-checkbox>
                                            </v-flex>
                                        </v-layout>
                                    </v-layout>
                                    <v-layout row>
                                        <v-text-field
                                            v-model="fields[category.key]"
                                            class="email-input"
                                            outline
                                            single-line
                                        ></v-text-field>
                                        <sp-button @click.native="addEmailToCategory(category.key, fields[category.key])" text="Add" icon="add"></sp-button>
                                    </v-layout>
                                    <v-layout column v-if="settings.categories[category.key] && settings.categories[category.key].emails">
                                        <div class="email" v-for="email in settings.categories[category.key].emails">
                                            <span>{{ email }}</span>
                                            <sp-button @click.native="removeEmailFromCategory(category.key, email)" sp-class="width-auto" design-type="table-button" icon="delete"></sp-button>
                                        </div>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end row>
                                <sp-button @click.native="updateNotificationSettings" text="Save" icon="download"></sp-button>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-tab-item>

            <v-tab-item key="device-notification">
                <v-container fluid>
                    <v-layout row>
                        <v-flex class="section">
                            <div class="section-title">Device Notifications</div>
                            <v-layout row wrap>
                                <v-flex md6 class="section notification-group">
                                    <v-layout column>
                                        <v-flex shrink text-center>
                                            <div class="label label--category">Period</div>
                                            <div class="organization-notifications-view__select">
                                                <sp-select
                                                    v-model="days"
                                                    :value="days"
                                                    :items="weekdays"
                                                    multiple
                                                    item-text="name"
                                                    item-value="value"
                                                ></sp-select>
                                            </div>
                                        </v-flex>
                                    </v-layout>

                                    <v-layout row>
                                        <v-text-field
                                            v-model="deviceFields"
                                            class="email-input"
                                            outline
                                            single-line
                                        ></v-text-field>
                                        <sp-button @click.native="addEmailDeviceNotifications(deviceFields)" text="Add" icon="add"></sp-button>
                                    </v-layout>
                                    <v-layout column v-if="deviceSettings">
                                        <div class="email" v-for="email in deviceSettings.recipients">
                                            <span>{{ email }}</span>
                                            <sp-button @click.native="removeEmailFromDeviceNotifications(email)" design-type="table-button" sp-class="width-auto" icon="delete"></sp-button>
                                        </div>
                                    </v-layout>
                                    <v-layout column>
                                        <div class="types-wrapper">
                                            <div class="label label--category">File type</div>
                                            <sp-select
                                                v-model="fileTypes"
                                                :value="fileTypes"
                                                :items="fileTypesItems"
                                                multiple
                                                item-text="name"
                                                item-value="value"
                                            ></sp-select>
                                        </div>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end row>
                                <sp-button @click.native="updateDeviceSettings" text="Save" icon="download"></sp-button>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-tab-item>
        </v-tabs-items>
        <sp-loader v-if="isLoading"></sp-loader>
    </div>
</template>

<script>
// TODO: fields[categoryKey].events[eventId] = true/false, potem iterowac po .events i dodawac/odejmowac z tablicy form

import SpButton from '@/components/forms/Button'
import toast from '@/plugins/izitoast'
import FleetSettingsApi from '@/api/FleetSettingsApi'
import { mapGetters } from 'vuex'
import SpLoader from '@/components/atoms/Loader'
import SpSelect from '@/components/atoms/Select'
import isEmpty from 'lodash-es/isEmpty'
import { bitFlagToArray } from '@/helpers/Utils'

const fleetSettingsApi = new FleetSettingsApi()

export default {
    name: 'FleetNotificationSettings',
    mounted () {
        this.id = this.$route.params.fleetUuid
        this.getNotificationSettings()
        this.getDeviceNotificationSettings()
    },
    components: {
        SpButton,
        SpLoader,
        SpSelect
    },
    data () {
        return {
            isLoading: true,
            fields: {
                categories: {}
            },
            settings: {
                categories: {}
            },
            tab: 0,
            deviceSettings: {
                daily: 0,
                id: '',
                fleetId: '',
                filetype: 1,
                recipients: []
            },
            deviceFields: null,
            days: null,
            weekdays: [
                {
                    name: 'Monday',
                    value: 1
                },
                {
                    name: 'Tuesday',
                    value: 2
                },
                {
                    name: 'Wednesday',
                    value: 4
                },
                {
                    name: 'Thursday',
                    value: 8
                },
                {
                    name: 'Friday',
                    value: 16
                },
                {
                    name: 'Saturday',
                    value: 32
                },
                {
                    name: 'Sunday',
                    value: 64
                }
            ],
            fileTypes: null,
            fileTypesItems: [
                {
                    name: 'PDF',
                    value: 1
                },
                {
                    name: 'CSV',
                    value: 2
                }
            ]
        }
    },
    computed: {
        ...mapGetters('dictionaryModule', [
            'getEventCategories',
            'getEventTypes'
        ]),
        availableCategories () {
            const availableCategories = [1, 2, 3, 5]

            return this.getEventCategories.filter(category => availableCategories.includes(category.id))
        },
        fieldCategoriesEmpty () {
            return isEmpty(this.fields.categories)
        }
    },
    methods: {
        addEmailDeviceNotifications (deviceNotificationsEmail) {
            if (this.deviceSettings.recipients.includes(deviceNotificationsEmail)) {
                toast.error('This email already exists')
                return
            }
            if (!this.validateEmail(deviceNotificationsEmail)) {
                toast.error('This is not a valid email')
                return
            }
            this.deviceSettings.recipients.push(deviceNotificationsEmail)
            this.deviceFields = ''
        },
        addEmailToCategory (categoryKey, email) {
            if (this.settings.categories[categoryKey].emails.includes(email)) {
                toast.error('This email already exists')
                return
            }
            if (!this.validateEmail(email)) {
                toast.error('This is not a valid email')
                return
            }
            this.settings.categories[categoryKey].emails.push(email)
            this.fields[categoryKey] = ''
        },
        validateEmail (email) {
            let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return re.test(String(email).toLowerCase())
        },
        removeEmailFromCategory (categoryKey, email) {
            this.settings.categories[categoryKey].emails = this.settings.categories[categoryKey].emails.filter(val => val !== email)
        },
        removeEmailFromDeviceNotifications (email) {
            this.deviceSettings.recipients = this.deviceSettings.recipients.filter(val => val !== email)
        },
        getEventsOfCategory (categoryId) {
            return this.getEventTypes.filter(type => type.categoryId === categoryId)
        },
        checkEventTypes (categoryKey) {
            if (this.settings.categories[categoryKey].eventTypes.length === this.fields.categories[categoryKey].availableEvents.length) {
                this.fields.categories[categoryKey].isAll = true
            } else {
                this.fields.categories[categoryKey].isAll = false
            }
        },
        checkAllEvents (event, categoryKey) {
            if (event) {
                this.settings.categories[categoryKey].eventTypes = this.fields.categories[categoryKey].availableEvents.map(event => event.id)
            } else {
                this.settings.categories[categoryKey].eventTypes = []
            }
        },
        async getNotificationSettings () {
            this.isLoading = true
            const response = await fleetSettingsApi.getEventNotificationSettings(this.id)
            if (!response.isSuccess) {
                toast.error('There was an error while downloading fleet settings')
                this.isLoading = false
                return
            }

            this.settings.categories = response.payload.categories
            this.availableCategories.forEach(category => {
                const categoryEvents = this.getEventsOfCategory(category.id)
                if (isEmpty(response.payload.categories)) {
                    this.settings.categories[category.key] = {
                        emails: [],
                        eventTypes: []
                    }
                }
                this.fields.categories[category.key] = {
                    isAll: categoryEvents.length === this.settings.categories[category.key].eventTypes.length,
                    availableEvents: categoryEvents
                }
            })
            this.fields = Object.assign({}, this.fields)
            this.settings = Object.assign({}, this.settings)
            this.isLoading = false
        },
        async updateNotificationSettings () {
            this.isLoading = true
            const response = await fleetSettingsApi.updateEventNotificationSettings(this.id, this.settings.categories)

            if (!response.isSuccess || !response.payload) {
                toast.error('There was an error while updating notification settings')
                this.isLoading = false
                return
            }

            await this.getNotificationSettings()
            toast.success('Notifications settings updated successfully')
        },
        async getDeviceNotificationSettings () {
            this.isLoading = true

            const response = await fleetSettingsApi.getDeviceNotificationSettings(this.id)

            if (!response.isSuccess) {
                toast.error('There was an error while downloading device settings')
                this.isLoading = false
                return
            }
            this.deviceSettings = response.payload
            this.days = bitFlagToArray(response.payload.daily)
            if (null === this.deviceSettings.recipients) {
                this.deviceSettings.recipients = []
            }
            this.fileTypes = bitFlagToArray(response.payload.filetype)
            if (null === this.deviceSettings.filetype) {
                this.deviceSettings.filetype = []
            }
            this.isLoading = false
        },
        async updateDeviceSettings () {
            this.isLoading = true
            if (null != this.days) {
                let sumDaysNumber = 0
                this.days.forEach((elem) => {
                    sumDaysNumber += elem
                })
                this.deviceSettings.daily = sumDaysNumber
            } else {
                this.deviceSettings.daily = 0
            }
            if (null != this.fileTypes) {
                let sumFileTypesNumber = 0
                this.fileTypes.forEach((elem) => {
                    sumFileTypesNumber += elem
                })
                this.deviceSettings.filetype = sumFileTypesNumber
            } else {
                this.deviceSettings.filetype = 0
            }

            if (null != this.fileTypes) {
                let sumFileTypesNumber = 0
                this.fileTypes.forEach((elem) => {
                    sumFileTypesNumber += elem
                })
                this.deviceSettings.filetype = sumFileTypesNumber
            } else {
                this.deviceSettings.filetype = 0
            }
            this.deviceSettings.fleetId = this.id
            const response = await fleetSettingsApi.updateDeviceNotificationSettings(this.deviceSettings)

            if (!response.isSuccess || !response.payload) {
                toast.error('There was an error while updating notification device settings')
                this.isLoading = false
                return
            }

            await this.getDeviceNotificationSettings()
            this.isLoading = false
        }
    }
}
</script>

<style scoped lang="scss">
.fleet-notifications-view {
    .section-title {
        font-weight: bold;
        font-size: 20px;
        margin-bottom: 10px;
    }
    .info-block {
        margin-bottom: 20px;
    }

    .label {
        position: relative;
        margin-bottom: 5px;

        &--category {
            font-weight: 700;
        }

    }

    .section {
        //border-right: 2px solid $primary;
        padding: 0 10px;

        &:last-child {
            border-right-color: transparent;
        }
    }

    &::v-deep .theme--dark.v-tabs__bar {
        background-color: $secondary;
    }

    &::v-deep .accent {
        background-color: $primary !important;
        border-color: $primary !important;
    }

    &::v-deep .v-tabs__slider {
        height: 4px;
    }

    &::v-deep .v-tabs__div a {
        text-decoration: none !important;
    }
}

.close {
    position: absolute;
    top: 18px;
    right: 20px;
    cursor: pointer;

    &:hover {
        opacity: 0.7;
    }
}

.notification-group {
    margin-bottom: 20px;
}

.notification-checkbox {
    margin-left: 5px !important;

    ::v-deep &.v-input .v-input__slot {
        min-height: 0 !important;
    }
}

.email {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 5px 0;
    border-bottom: 1px solid #eee;

    &:last-child {
        border-bottom: none;
    }

    ::v-deep .btn {
        margin: 0;
    }
}

.email-input {
    ::v-deep &.v-input .v-input__slot {
        border-top-right-radius: 0!important;
        border-bottom-right-radius: 0!important;
    }
}

.types-wrapper {
    margin-top: 20px;
}
</style>
